export default {
  tour: {
    step: "STEP {n} OF {total}",
    skip: "Skip tutorial",
    previous: "← Previous",
    next: "Next →",
    finish: "Finish",
    welcomeTitle: "Welcome to HelixScan",
    welcomeBody: "HelixScan monitors the official sources of the Spanish pharmaceutical market (AEMPS, BOE, SNS, CIPM, EMA…) for you and alerts you to the events that affect your products and your competitors. This 2-minute tutorial shows you the essentials.",
    dashboardTitle: "Dashboard",
    dashboardBody: "Your daily summary: how many events have been detected today and this week, which ones affect your portfolio or your competitors, the status of each source and the activity of the last 7 days.",
    changesTitle: "Detected events",
    changesBody: "All events: prices, funding, deductions, exclusions and safety alerts. Filter by type, priority or tag, and click any product to open its full record (CIMA + funding + history).",
    historyTitle: "History",
    historyBody: "Monthly archive of events since 2010. Click a day to see exactly what changed on that date.",
    radarTitle: "Regulatory Radar",
    radarBody: "The month's regulatory events in 4 lanes: prices, funding, authorizations and regulatory (CMH, SPRAH, EMA, BOE…). Ideal for preparing the monthly committee.",
    productsTitle: "My Products",
    productsBody: "Your portfolio. Events affecting these products are tagged with your organization's label and get high priority.",
    competitorsTitle: "Competitors",
    competitorsBody: "Competitor products you want to monitor: direct (same molecule) and therapeutic (same area). Their events are tagged as Competitor.",
    alertsTitle: "Email alerts",
    alertsBody: "Subscribe to specific change types or active substances and receive an email as soon as they're detected. There's also a configurable daily summary in Preferences.",
    trendsTitle: "Predictions",
    trendsBody: "Price forecast models per product based on 15 years of history: risk of rises/falls, opportunities and events that explain each movement.",
    pricesTitle: "Price Comparator",
    pricesBody: "Compare the PVL evolution of your products with that of all competitors of the same molecule, with 15 years of SNS price history.",
    sourcesTitle: "Sources",
    sourcesBody: "The official sources monitored, their frequency and their last review. HelixScan polls them automatically every 30 minutes during business hours.",
    doneTitle: "All set!",
    doneBody: "You now know the essentials. You can watch this tutorial again whenever you want from the ? button in the top bar. If your portfolio is still empty, set it up in My Products.",
  },
};
